import React, { ChangeEvent, Component, useState } from "react";
import "./TimelineNoteModal.scss";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IOrder_Progress_State from "../../../models/IOrder_Progress_State";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTextArea from "../../shared/OwTextArea/OwTextArea";
import OwTitle from "../../shared/OwTitle/OwTitle";

type Props = {
    commitModalFn: (nextStep?: IOrder_Progress_State, note?: string, internal_note?: string, customMessage?: string) => void;
    closeModalFn: () => void;
    nextStep?: IOrder_Progress_State;
    userModel: IUserUI;
};

export const TimelineNoteModal: React.FC<Props> = (props) => {
    const [note, setNote] = useState("");
    const [internalNote, setInternalNote] = useState("");
    const [customMessage, setCustomMessage] = useState("");

    const closeModal = () => {
        props.closeModalFn();
    };

    const saveDetails = () => {
        props.commitModalFn(props.nextStep, note, internalNote, customMessage);
    };

    const create = () => {};

    const handleChange = (e: ChangeEvent<any>) => {
        const name = e.target.name;
        const value = e.target.value;

        switch (name) {
            case "note":
                setNote(value);
                break;

            case "internal_note":
                setInternalNote(value);
                break;

            case "custom_message":
                setCustomMessage(value);
                break;
        }
    };

    const hasCustomMessage = !!props.nextStep?.allowCustomMessage;

    return (
        <div className={"TimelineNoteModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle
                        leftIconName={hasCustomMessage ? "fad fa-envelope" : "fad note"}
                        title={hasCustomMessage ? "submit_with_message" : "timeline_note"}
                        tag={"h3"}
                    />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div className={"w-100"}>
                <div className={"mt-3 mb-3 text-muted"}>
                    <OwLabel title={hasCustomMessage ? "help_text_submit_with_custom_message" : "help_text_add_timeline_note"} />
                </div>

                {props.nextStep?.allowCustomMessage ? (
                    <div className={"mb-3"}>
                        <div>
                            <OwLabel title={"outbound_message"} />
                        </div>
                        <div>
                            <OwTextArea name={"custom_message"} fn={handleChange} value={customMessage} />
                        </div>
                    </div>
                ) : null}

                <div>
                    <div>
                        <OwLabel title={"note"} />
                    </div>
                    <div>
                        <OwTextArea name={"note"} fn={handleChange} value={note} />
                    </div>
                </div>

                {props.userModel.isSupplierUser ? (
                    <div className={"mt-3"}>
                        <div>
                            <OwLabel title={"internal_note"} />
                        </div>
                        <div>
                            <OwTextArea name={"internal_note"} fn={handleChange} value={internalNote} />
                        </div>
                    </div>
                ) : null}
            </div>

            <div className={"mt-3 2-100"}>
                <OwButton leftIconClass={"fas fa-save"} title={"save"} fn={saveDetails} />
            </div>
        </div>
    );
};
